import * as React from "react";
import { Box, List, ListItem, ListItemText } from "@mui/material";
import { MiscWorkRecord } from "../miscWorkData";

export type NotesProps = {
    record: MiscWorkRecord;
};

const Notes: React.FC<NotesProps> = (props) => {
    return (
        <Box sx={{ width: 1, p: 3 }}>
            <List dense sx={{ width: 1 }}>
                {props.record.notes.map((note) => (
                    <ListItem key={note.id} alignItems="flex-start" disableGutters>
                        <ListItemText
                            primary={note.note}
                            secondary={`${note.createdBy} - ${new Date(note.created).toLocaleString()}`}
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default Notes;